module.exports = __webpack_public_path__ + "media/avatars/mustache-d6917df8.svg";